import axios from "axios";

//const API_BASE_URL = "http://127.0.0.1:8000"; // Backend-URL-DEV
const API_BASE_URL = "https://api-react.devspielewiese.de"; // Backend-URL-DEV

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});
